// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"e94933f2","99":"769fd2d1","288":"8858e010"}[chunkId] + ".chunk.js";
};